import React from 'react';
import { Button, message } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';
import { quickOpenCardController } from './controller';
import { usePermissionControl } from '@/hooks/usePermissionControl';
import { ACTION_CONTROL } from '@/constants/action-permission';
import styles from './index.less';

export default function QuickOpenCardEntryButton() {
  const { hasPermission } = usePermissionControl();

  function handleClick() {
    if (
      !hasPermission(ACTION_CONTROL.CreateOrder) &&
      !hasPermission(ACTION_CONTROL.QuickOpenCard)
    ) {
      message.warning('无操作权限，请联系商家管理员');
      return;
    }
    quickOpenCardController.open();
  }

  return (
    <Button
      type="primary"
      size="middle"
      icon={<CreditCardOutlined />}
      className={styles.entryButton}
      onClick={handleClick}
    >
      快捷开卡
    </Button>
  );
}
